import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { SeguimientoModel } from 'src/app/models/visitas/seguimiento.model';


export class ViverosPereiraListModalFormDefinition {
  public readonly formFields: Form<SeguimientoModel>;
  public readonly model: Partial<SeguimientoModel>;

  constructor(type: FormType, model: Partial<SeguimientoModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'viveros-pereira-list-modal',
      header: 'Datos del seguimiento',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<SeguimientoModel>[] {
    return [
      {
        name: 'Datos',
        fields: [
          this.textField('año', 'Año', 1, true, 4),
          this.textField('semana', 'Semana', 2, true, 4),
          this.textField('fecha', 'Fecha', 3, true, 4),
          this.textField('cultivo', 'Planta', 4, true, 4),
          this.textField('variedad', 'Variedad', 5, true, 4),
          this.textField('semana_siembra', 'Semana Siembra', 6, true, 4),
          this.textField('semana_entrega', 'Semana Entrega', 7, true, 4),
          this.textField('remesa', 'Remesa', 8, true, 4),
          this.textField('observaciones', 'Observaciones', 9, true, 12, InputType.TEXTAREA),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
      {
        name: 'Seguimiento',
        fields: [
          this.textField('cuestiones', 'Cuestiones', 1, true, 4, InputType.TEXTAREA),
          this.textField('medida', 'Medida', 2, true, 4, InputType.TEXTAREA),
          this.textField('resultados', 'Resultados', 3, true, 4, InputType.TEXTAREA),
          this.textField('etiquetas_nombre', 'Etiquetas', 4, true, 12, InputType.TEXTAREA),
        ],
        width: 12,
        isVisible: true,
        order: 2,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<SeguimientoModel> {
    return {
      name,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
